module.exports = __webpack_public_path__ + "static/media/ico-print.c0250c97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ico-print.svg
// module id = 1318
// module chunks = 0